import React, { useMemo, useRef, useState } from "react"
import { useMapEvents } from "react-leaflet"
import { Box } from "@mui/material"

const OVER_LAYER =
  ".leaflet-interactive, .leaflet-marker-icon, .leaflet-popup, .leaflet-tooltip"

// Only over bare map: markers, lines and panels bring their own affordances.
const overBareMap = (target, container) =>
  target === container ||
  (!!target?.closest?.(".leaflet-pane") && !target.closest(OVER_LAYER))

// `text` is a string or a function of the cursor's latlng.
export default function PlannerCursorHint({ text }) {
  const [cursor, setCursor] = useState(null)
  const textRef = useRef(text)
  textRef.current = text

  // Stable handlers: otherwise every mousemove re-render rebinds the map listeners.
  const handlers = useMemo(
    () => ({
      mousemove: (e) =>
        setCursor(
          textRef.current &&
            !e.originalEvent?.buttons &&
            overBareMap(e.originalEvent?.target, e.target.getContainer())
            ? { point: e.containerPoint, latlng: e.latlng }
            : null,
        ),
      click: () => setCursor(null),
      mouseout: () => setCursor(null),
      dragstart: () => setCursor(null),
    }),
    [],
  )
  useMapEvents(handlers)

  const label = typeof text === "function" && cursor ? text(cursor.latlng) : text
  if (!label || !cursor) return null
  const { point } = cursor
  return (
    <Box
      sx={{
        position: "absolute",
        left: point.x + 14,
        top: point.y + 14,
        zIndex: 1000,
        pointerEvents: "none",
        px: 0.75,
        py: 0.25,
        fontSize: 12,
        color: "#004f7d",
        bgcolor: "rgba(255,255,255,0.95)",
        borderRadius: 1,
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  )
}
